module.exports = __webpack_public_path__ + "img/lesinger.6a19e6f6.jpg";